import IStorage from "./IStorage";
import LocalStorage from "./localStorage";

const AppStorage: IStorage = LocalStorage.getInstance();

export default AppStorage;
